// 业务错误码
const codeMap: Record<string, string> = {
  'DEP_APP-106': '登录已过期，请重新登录',
};

export default codeMap;
